export const useGetParams = () => {
  const searchParams = new URL(document.location).searchParams;
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user'),
    bg: searchParams.get('bg') || '1',
    title: getDefaultValue(
      searchParams.get('title'),
      'Qual é sua expectativa para o Desafio 2026 em uma palavra?',
    ),
    qrCode1: searchParams.get('qrCode1'),
    qrCode2: searchParams.get('qrCode2'),
    sizeQR: searchParams.get('sizeQR') || '20',
    titleFontSize: searchParams.get('titleFontSize') || '5.6',
    minFontWords: searchParams.get('minFontWords') || 30,
    maxFontWords: searchParams.get('maxFontWords') || 70,
    requestInterval: Number(searchParams.get('requestInterval') || 2000),
    demo: searchParams.get('demo') || false,
    extraQrText: getDefaultValue(
      searchParams.get('extraQrText'),
      'use o qr code para enviar sua palavra pelo whatsapp',
    ),

    paddingQR: searchParams.get('paddingQR') || '0',
    qrTitle1: getDefaultValue(searchParams.get('qrTitle1'), 'Telegram'),
    qrTitle2: getDefaultValue(searchParams.get('qrTitle2'), 'WhatsApp'),
    // phoneNumberFontSize: searchParams.get('phoneNumberFontSize') || 5,
  };
};
